import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export const LANGUAGE = [
  {
    code: 'fr',
    name: 'Français',
  },
  {
    code: 'en',
    name: 'English',
  },
];

export const LANGUAGE_BRIEF = [
  {
    code: 'fr',
    name: 'FR',
  },
  {
    code: 'en',
    name: 'EN',
  },
];

export const HttpLoaderFactory = (http: HttpClient) => {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
};
